import { render, staticRenderFns } from "./ICMButton.vue?vue&type=template&id=0b625586&scoped=true&"
import script from "./ICMButton.vue?vue&type=script&lang=ts&"
export * from "./ICMButton.vue?vue&type=script&lang=ts&"
import style0 from "./ICMButton.vue?vue&type=style&index=0&id=0b625586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b625586",
  null
  
)

export default component.exports